import Vue from 'vue'

import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import HomeMap from '@/components/maps/HomeMap'

import About from '@/components/about/About'
import Help from '@/components/about/Help'

// Dashboards & Reporting
import Dashboard from '@/components/dashboard/Dashboard'

import BackhaulDashboard from '@/components/dashboard/backhaul/BackhaulDashboard'

// import SharerDashboard from '@/components/dashboard/sharers/SharerDashboard'
import FinanceSummary from '@/components/dashboard/views/FinanceSummary'
import PropertyDashboard from '@/components/dashboard/property/PropertyDashboard'
import UtilityReport from '@/components/dashboard/utility/UtilityReport'
import ProjectSummary from '@/components/dashboard/views/ProjectSummary'

import ProgressReport from '@/components/dashboard/progress/ProgressReport'


// Sites
import SitesTable from '@/components/tables/SitesTable'
import RequestsView from '@/components/requests/RequestsView'

import Equip from '@/components/assets/EquipView'
import EventsCalendar from '@/components/atoms/EventsCalendar'


// Finance
import StatementView from '@/components/dashboard/finance/StatementView'
import InvoicingView from '@/components/finance/InvoicingView'
import RevenueReport from '@/components/dashboard/finance/RevenueReport'
import BackhaulTable from '@/components/backhaul/BackhaulTable'
import UtilitiesTable from '@/components/utility/UtilitiesTable'


// Property
import PropertyLandlords from '@/components/dashboard/property/PropertyLandlords'
import PropertyExpiry from '@/components/dashboard/property/PropertyExpiry'
import PropertyRentalMonth from '@/components/dashboard/property/PropertyRentalMonth'
import TenancyDue from '@/components/dashboard/property/TenancyDue'


// Maintenance
import MaintView from '@/components/maintenance/MaintenanceView'
import MaintCalendar from '@/components/maintenance/MaintCalendar'

// import SiteOmsTasks from '@/containers/SiteOmsTasks'
// import Workflow from '@/containers/Workflow'


// Profile & Settings
import UserProfile from '@/components/login/UserProfile'
import SettingsView from '@/components/settings/SettingsView'

import Login from '@/components/login/Login'
import Logout from '@/components/login/Logout'

import {settings} from '@/components/Data'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/map',
      name: 'Map',
      component: HomeMap
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard/backhaul',
      name: 'Backhaul Dashboard',
      component: BackhaulDashboard
    },
    {
      path: '/dashboard/projects',
      name: 'Project Dashboard',
      component: ProjectSummary
    },
/*
    {
      path: '/dashboard/sharers',
      name: 'Sharer Dashboard',
      component: SharerDashboard
    },
*/
    {
      path: '/dashboard/finance',
      name: 'Finance Summary',
      component: FinanceSummary
    },
    {
      path: '/dashboard/property',
      name: 'Property Dashboard',
      component: PropertyDashboard
    },
    {
      path: '/dashboard/utility',
      name: 'Utility Dashboard',
      component: UtilityReport
    },
    {
      path: '/dashboard/requests',
      name: 'Dashboard Requests',
      component: Dashboard
    },
    {
      path: '/dashboard/maintenance',
      name: 'Maintenance Dashboard',
      component: MaintView
    },
    {
      path: '/dashboard/progress',
      name: 'Progress',
      component: ProgressReport
    },
    {
      path: '/calendar',
      name: 'Events Calendar',
      component: EventsCalendar
    },
    {
      path: '/sites/:view?',
      name: 'All Sites',
      component: SitesTable
    },
/*
    {
      path: '/sites/id/:siteId',
      name: 'Site by Site ID',
      component: SitesTable
    },
*/
    {
      path: '/requests/:type?/:sharerId?',
      name: 'Requests',
      component: RequestsView
    },
    {
      path: '/backhaul',
      name: 'Backhaul',
      component: BackhaulTable
    },
    {
      path: '/assets',
      name: 'Equip',
      component: Equip
    },
    {
      path: '/property/rentals',
      name: 'Rentals By Month',
      component: PropertyRentalMonth
    },
    {
      path: '/property/due',
      name: 'Tenancy Due',
      component: TenancyDue
    },
    {
      path: '/property/expiry',
      name: 'Tenancy Expiry',
      component: PropertyExpiry
    },
    {
      path: '/property/landlords',
      name: 'Landlords',
      component: PropertyLandlords
    },
    {
      path: '/statements',
      name: 'Statements',
      component: StatementView
    },
    {
      path: '/revenue',
      name: 'Sharer Revenue',
      component: RevenueReport
    },
    {
      path: '/invoices',
      name: 'Invoicing',
      component: InvoicingView
    },
    {
      path: '/utility',
      name: settings.utilLabel + ' Bills',
      component: UtilitiesTable
    },
    {
      path: '/tickets/:status?/:priority?/:ownerId?',
      name: 'Tickets',
      props: true,
      component: MaintView
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: MaintCalendar
    },
    {
      path: '/profile',
      name: 'User Profile',
      component: UserProfile
    },
    {
      path: '/settings',
      name: 'Settings',
      component: SettingsView
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logged Out',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js